import { render } from "./AnimatedProjectArtwork.vue?vue&type=template&id=50106480"
import script from "./AnimatedProjectArtwork.vue?vue&type=script&lang=js"
export * from "./AnimatedProjectArtwork.vue?vue&type=script&lang=js"

import "./AnimatedProjectArtwork.vue?vue&type=style&index=0&id=50106480&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__